import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "cn";
import type { ComponentProps } from "react";

const statusDotVariants = cva("size-1.5 shrink-0 rounded-full", {
  variants: {
    state: {
      online: "bg-online",
      off: "bg-foreground/20",
    },
  },
  defaultVariants: {
    state: "off",
  },
});

/**
 * Точка состояния: включено (`online`) или выключено (`off`). Декоративна:
 * смысл несёт соседний текст, цвет в одиночку ничего не сообщает.
 */
function StatusDot({
  className,
  state = "off",
  ...props
}: Omit<ComponentProps<"span">, "children"> & VariantProps<typeof statusDotVariants>) {
  return (
    <span
      data-slot="status-dot"
      data-state={state}
      aria-hidden="true"
      className={cn(statusDotVariants({ state }), className)}
      {...props}
    />
  );
}

export { StatusDot, statusDotVariants };
